if (!customElements.get("cart-drawer")) {
  customElements.define(
    "cart-drawer",
    class CartDrawer extends Drawer {
      constructor() {
        super();
      }

      connectedCallback() {
        document.addEventListener(
          "cart-drawer:refresh",
          this.handleRefresh.bind(this),
        );
      }

      disconnectedCallback() {
        document.removeEventListener(
          "cart-drawer:refresh",
          this.handleRefresh.bind(this),
        );
      }

      handleRefresh() {
        const cartItems = this.querySelector("cart-items");
        const sectionId = cartItems?.dataset.section;
        if (!sectionId) return;

        const sections = [sectionId, "cart-icon-bubble"];

        fetch(
          `${window.location.pathname}?sections=${sections.join(",")}`,
        )
          .then((r) => r.json())
          .then((response) => {
            SectionDynamicUpdate.updateSections(
              [
                {
                  id: "Cart-Drawer",
                  section: sectionId,
                  selector: "#Cart-Drawer-Details",
                },
                {
                  id: "Cart-Icon-Bubble",
                  section: "cart-icon-bubble",
                  selector: ".shopify-section",
                },
              ],
              response,
            );

            webvista.publish(PUB_SUB_EVENTS.cartUpdate, {
              source: "cart-drawer-refresh",
              cartData: null,
            });
          });
      }

      show(opener) {
        super.show(opener);

        // 由于购物车的Dom内容会被替换，所以需要重新获取
        const recommendationByHistory = this.querySelector(
          "recommendation-by-history",
        );
        if (recommendationByHistory) recommendationByHistory.showContent();
      }

      hide() {
        super.hide();

        const recommendationByHistory = this.querySelector(
          "recommendation-by-history",
        );
        if (recommendationByHistory) recommendationByHistory.abortFetch();
      }
    },
  );
}
